export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            热门推荐
          </h2>
          <p className="mt-2 text-sm text-foreground-500 font-label">精选热门影视，总有一部适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20action%20scene%20with%20explosive%20warm%20lighting%2C%20coral%20and%20amber%20color%20grading%2C%20movie%20aesthetic%2C%20dramatic%20motion%20blur%2C%20high%20contrast%2C%20no%20text%20or%20faces&width=700&height=400&seq=card-nc-01&orientation=landscape"
                alt="动作电影推荐"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                燃爆 · 动作大片合集
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label line-clamp-2">
                精选动作类型高分影片，紧张刺激不容错过
              </p>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Suspenseful%20drama%20cinematic%20visual%20with%20warm%20amber%20lighting%2C%20emotional%20atmosphere%2C%20film%20aesthetic%2C%20soft%20contrast%2C%20storytelling%20mood%2C%20no%20text%20or%20faces&width=700&height=400&seq=card-nc-02&orientation=landscape"
                alt="剧情片推荐"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                感人 · 剧情佳片精选
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label line-clamp-2">
                高分剧情片引发共鸣，温暖治愈直击人心
              </p>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Bright%20romantic%20comedy%20cinematic%20visual%20with%20warm%20golden%20lighting%2C%20cheerful%20atmosphere%2C%20soft%20coral%20tones%2C%20happy%20mood%2C%20film%20aesthetic%2C%20no%20text%20or%20faces&width=700&height=400&seq=card-nc-03&orientation=landscape"
                alt="喜剧电影推荐"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                欢乐 · 喜剧爆笑合集
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label line-clamp-2">
                治愈不开心，笑到停不下来的喜剧片单
              </p>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Mysterious%20thriller%20atmosphere%20with%20dark%20coral%20and%20amber%20accent%20lighting%2C%20shadowy%20mood%2C%20suspenseful%20film%20aesthetic%2C%20noir%20style%2C%20no%20text%20or%20faces&width=700&height=400&seq=card-nc-04&orientation=landscape"
                alt="悬疑片推荐"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                烧脑 · 悬疑推理专场
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label line-clamp-2">
                层层反转烧脑不断，考验你的观察力
              </p>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Anime%20style%20colorful%20visual%20with%20warm%20coral%20and%20amber%20gradient%20lighting%2C%20fantasy%20atmosphere%2C%20vibrant%20energy%2C%20animation%20aesthetic%2C%20no%20text%20or%20characters&width=700&height=400&seq=card-nc-05&orientation=landscape"
                alt="动漫推荐"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                热血 · 动漫番剧推荐
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label line-clamp-2">
                国漫日漫精选，精彩剧情每周更新追不停
              </p>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20drama%20cinematic%20visual%20with%20warm%20amber%20lighting%2C%20romantic%20atmosphere%2C%20soft%20coral%20tones%2C%20emotional%20mood%2C%20film%20aesthetic%2C%20no%20text%20or%20faces&width=700&height=400&seq=card-nc-06&orientation=landscape"
                alt="韩剧推荐"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                心动 · 韩剧精选剧场
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label line-clamp-2">
                高分韩剧一网打尽，追剧神器随身看
              </p>
            </div>
          </div>

          <div className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 cursor-pointer">
            <div className="h-40 md:h-44 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Nature%20documentary%20style%20visual%20with%20warm%20golden%20hour%20lighting%2C%20earth%20tones%2C%20cinematic%20landscape%20aesthetic%2C%20atmospheric%20mood%2C%20no%20text%20or%20animals&width=700&height=400&seq=card-nc-07&orientation=landscape"
                alt="纪录片推荐"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-4">
              <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-700 transition-colors line-clamp-1">
                深度 · 纪录片精选集
              </h3>
              <p className="mt-1 text-xs text-foreground-500 font-label line-clamp-2">
                自然与人文纪实，打开认知世界的窗口
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}